var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner transcribe-dialog",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Message.CopyShippingMarkAndName"),
        width: "1000px",
        "close-on-click-modal": false,
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "padding-bottom": "20px" }
        },
        [
          _c(
            "el-form",
            {
              staticStyle: { width: "100%" },
              attrs: { "label-width": "70px", "label-position": "left" }
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_CustomerName")
                          }
                        },
                        [
                          _c("cargo-company-select", {
                            attrs: {
                              "method-params": { customer: true },
                              "default-value": _vm.filter.customer,
                              no: "1"
                            },
                            on: {
                              change: function(p) {
                                _vm.filter.customer = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("queryJob.englishDescriptionOfGoods")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "2" },
                            model: {
                              value: _vm.filter.cargoEnglishName,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "cargoEnglishName", $$v)
                              },
                              expression: "filter.cargoEnglishName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("SeaExport.Marks") } },
                        [
                          _c("el-input", {
                            attrs: { no: "3" },
                            model: {
                              value: _vm.filter.mark,
                              callback: function($$v) {
                                _vm.$set(_vm.filter, "mark", $$v)
                              },
                              expression: "filter.mark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "4" },
                          on: {
                            click: function($event) {
                              _vm.filter.pageNum = 1
                              _vm.toQuery()
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Query")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "5" },
                          on: { click: _vm.reset }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Empty")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("cargo-ag-grid", {
        staticStyle: { height: "300px" },
        attrs: {
          "grid-options": _vm.gridOptions,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.rowData
        },
        on: {
          gridReady: function(params) {
            _vm.gridApi = params.api
          }
        }
      }),
      _c("cargo-pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total>0"
          }
        ],
        attrs: {
          total: _vm.total,
          page: _vm.filter.pageNum,
          limit: _vm.filter.pageSize
        },
        on: {
          "update:page": function($event) {
            return _vm.$set(_vm.filter, "pageNum", $event)
          },
          "update:limit": function($event) {
            return _vm.$set(_vm.filter, "pageSize", $event)
          },
          pagination: _vm.toQuery
        }
      }),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "6" },
              on: {
                click: function($event) {
                  return _vm.choose(["cargoEnglishName", "mark", "hsCode"])
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.SelecteAll")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "7" },
              on: {
                click: function($event) {
                  return _vm.choose(["cargoEnglishName"])
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_EnglishCargoName")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "8" },
              on: {
                click: function($event) {
                  return _vm.choose(["mark"])
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Marks")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "9" },
              on: {
                click: function($event) {
                  return _vm.choose(["hsCode"])
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_HsCode")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }